// removed by extract-text-webpack-plugin
module.exports = {"root":"MasterworkCatalyst--root--1C","inner":"MasterworkCatalyst--inner--10","tick":"MasterworkCatalyst--tick--1p","screenshot":"MasterworkCatalyst--screenshot--30","objectives":"MasterworkCatalyst--objectives--38","masterworkComplete":"MasterworkCatalyst--masterworkComplete--3d","plugIcon":"MasterworkCatalyst--plugIcon--1B","itemLink":"MasterworkCatalyst--itemLink--30","instance":"MasterworkCatalyst--instance--35","red":"MasterworkCatalyst--red--3S","green":"MasterworkCatalyst--green--2d","faded":"MasterworkCatalyst--faded--1X","completeMessage":"MasterworkCatalyst--completeMessage--1t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MasterworkCatalyst/styles.styl
// module id = 830
// module chunks = 0